import React from 'react';
import {
    makeStyles,
    Dropdown,
    Option,
    Label,
} from '@fluentui/react-components';
import { DatabaseRegular } from '@fluentui/react-icons';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, setDataset } from '../../utils/store';
import TabbedDrawerContent from '../Common/TabbedDrawerContent';
import DebugAnalyze from './DebugAnalyze';
import DebugSampleUsers from './DebugSampleUsers';
import DebugLatestDates from './DebugLatestDates';
import DebugSchema from './DebugSchema';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        paddingTop: '32px', // Space for the drawer header dismiss button
    },
    datasetRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '0 16px',
    },
    datasetDropdown: {
        minWidth: '180px',
    },
});

const Debug: React.FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const settings = useSelector((state: RootState) => state.settings);
    const dataset = settings.dataset;

    const tabs = [
        { value: 'analyze', label: 'Analyze Script', content: <DebugAnalyze dataset={dataset} /> },
        { value: 'sample', label: 'Sample Users', content: <DebugSampleUsers dataset={dataset} /> },
        { value: 'dates', label: 'Latest Dates', content: <DebugLatestDates dataset={dataset} /> },
        { value: 'schema', label: 'Schema', content: <DebugSchema dataset={dataset} /> },
    ];

    return (
        <div className={classes.container}>
            {settings.availableDatasets.length > 1 && (
                <div className={classes.datasetRow}>
                    <DatabaseRegular />
                    <Label>Dataset:</Label>
                    <Dropdown
                        className={classes.datasetDropdown}
                        value={settings.availableDatasets.find(d => d.name === dataset)?.displayName || dataset}
                        selectedOptions={[dataset]}
                        onOptionSelect={(_, data) => {
                            if (data.optionValue) {
                                dispatch(setDataset(data.optionValue));
                            }
                        }}
                    >
                        {settings.availableDatasets.map((ds) => (
                            <Option key={ds.name} value={ds.name}>
                                {ds.displayName}
                            </Option>
                        ))}
                    </Dropdown>
                </div>
            )}
            <TabbedDrawerContent tabs={tabs} defaultTab="analyze" />
        </div>
    );
};

export default Debug;